import axios from 'axios';
import { API_BASE_URL } from '../../config/api';
import { FormTheme } from '../../types';

export const templateApi = {
  getTemplates: async (
    tenantId: string,
    filters?: { formType?: string; targetDevice?: string; visibility?: 'global' | 'workspace' | 'private' }
  ) => {
    const params = new URLSearchParams();
    if (filters?.formType) params.append('formType', filters.formType);
    if (filters?.targetDevice) params.append('targetDevice', filters.targetDevice);
    if (filters?.visibility) params.append('visibility', filters.visibility);

    const response = await axios.get(
      `${API_BASE_URL}/tenant/${tenantId}/template?${params.toString()}`
    );
    return response.data;
  },

  getTemplate: async (tenantId: string, templateId: string) => {
    const response = await axios.get(
      `${API_BASE_URL}/tenant/${tenantId}/template/${templateId}`
    );
    return response.data;
  },

  createTemplate: async (
    tenantId: string,
    data: {
      name: string;
      description?: string;
      formType: 'single' | 'multistep';
      targetDevice?: 'mobile' | 'tablet' | 'desktop';
      configuration: any;
      steps?: string[];
      theme?: FormTheme | null;
      tags?: string[];
      visibility?: 'global' | 'workspace' | 'private';
    }
  ) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/tenant/${tenantId}/template`,
        data
      );
      return response.data;
    } catch (error: any) {
      if (error.response?.data) {
        throw new Error(error.response.data);
      }
      throw error;
    }
  },

  deleteTemplate: async (tenantId: string, templateId: string) => {
    const response = await axios.delete(
      `${API_BASE_URL}/tenant/${tenantId}/template/${templateId}`
    );
    return response.data;
  },
};
